const ENGLISH = $localize`:@@language-mapping.english:English - United States`;
const ARABIC = $localize`:@@language-mapping.arabic:Arabic`;
const SIMPLIFIED_CHINESE = $localize`:@@language-mapping.chinese:Chinese - Simplified`;
const TRADITIONAL_CHINESE = $localize`:@@language-mapping.traditional-chinese:Chinese - Traditional`;
const DANISH = $localize`:@@language-mapping.danish:Danish`;
const FRENCH = $localize`:@@language-mapping.french:French`;
const HUNGARIAN = $localize`:@@language-mapping.hungarian:Hungarian`;
const KOREAN = $localize`:@@language-mapping.korean:Korean`;
const PORTUGUESE_BRAZIL = $localize`:@@language-mapping.portuguese:Portuguese - Brazil`;
const SPANISH = $localize`:@@language-mapping.spanish:Spanish`;
const TURKISH = $localize`:@@language-mapping.turkish:Turkish`;
const GERMAN = $localize`:@@language-mapping.german:German`;
const DUTCH = $localize`:@@language-mapping.dutch:Dutch`;
const INDONESIAN = $localize`:@@language-mapping.indonesian:Indonesian`;
const NORWEGIAN = $localize`:@@language-mapping.norsk:Norwegian`;
const ROMANIAN = $localize`:@@language-mapping.romanian:Romanian`;
const SPANISH_MEXICO = $localize`:@@language-mapping.spanish-mexico:Spanish - Mexico‏`;
const UKRAINIAN = $localize`:@@language-mapping.ukrainian:Ukrainian`;
const GREEK = $localize`:@@language-mapping.greek:Greek`;
const ITALIAN = $localize`:@@language-mapping.italian:Italian`;
const POLISH = $localize`:@@language-mapping.polish:Polish`;
const RUSSIAN = $localize`:@@language-mapping.russian:Russian`;
const SWEDISH = $localize`:@@language-mapping.swedish:Swedish`;
const VIETNAMESE = $localize`:@@language-mapping.vietnamese:Vietnamese`;
const CZECH = $localize`:@@language-mapping.czech:Czech`;
const FINNISH = $localize`:@@language-mapping.finnish:Finnish`;
const HEBREW = $localize`:@@language-mapping.hebrew:Hebrew`;
const JAPANESE = $localize`:@@language-mapping.japanese:Japanese`;
const PORTUGUESE_PORTUGAL = $localize`:@@language-mapping.portuguese-portugal:Portuguese - Portugal`;
const SLOVAK = $localize`:@@language-mapping.slovak:Slovak‏`;
const THAI = $localize`:@@language-mapping.thai:Thai`;
const ICELANDIC = $localize`:@@language-mapping.icelandic:Icelandic`;

export const LANGUAGE_MAPPINGS_OEM = [
  {
    langCode: 'en_US',
    langName: 'English - United States',
    langInEng: ENGLISH
  },
  
  {
    langCode: 'ar_SA',
    langName: 'اللغة العربية',
    langInEng: ARABIC
  },
  {
    langCode: 'zh_CN',
    langName: '简体中文‏',
    langInEng: SIMPLIFIED_CHINESE
  },
  {
    langCode: 'zh_TW',
    langName: '繁體中文‏',
    langInEng: TRADITIONAL_CHINESE
  },
  {
    langCode: 'cs_CZ',
    langName: 'Čeština‏',
    langInEng: CZECH
  },
  {
    langCode: 'da_DK',
    langName: 'Dansk',
    langInEng: DANISH
  },
  {
    langCode: 'nl_NL',
    langName: 'Nederlands‏',
    langInEng: DUTCH
  },
  {
    langCode: 'fi_FI',
    langName: 'Suomi‏',
    langInEng: FINNISH
  },
  {
    langCode: 'fr_FR',
    langName: 'Français',
    langInEng: FRENCH
  },
  {
    langCode: 'de_DE',
    langName: 'Deutsch‏',
    langInEng: GERMAN
  },
  {
    langCode: 'el_GR',
    langName: 'Ελληνικά‏',
    langInEng: GREEK
  },
  {
    langCode: 'he_IL',
    langName: 'עברית‏',
    langInEng: HEBREW
  },
  {
    langCode: 'hu_HU',
    langName: 'Magyar',
    langInEng: HUNGARIAN
  },
  {
    langCode: 'is_IS',
    langName: 'íslenskur‏',
    langInEng: ICELANDIC
  },
  {
    langCode: 'id_ID',
    langName: 'Bahasa Indonesia‏',
    langInEng: INDONESIAN
  },
  {
    langCode: 'it_IT',
    langName: 'Italiano‏',
    langInEng: ITALIAN
  },
  {
    langCode: 'ja_JP',
    langName: '日本語',
    langInEng: JAPANESE
  },
  {
    langCode: 'ko_KR',
    langName: '한국어‏',
    langInEng: KOREAN
  },
  {
    langCode: 'nb_NO',
    langName: 'Norsk',
    langInEng: NORWEGIAN
  },
  {
    langCode: 'pl_PL',
    langName: 'Polski‏',
    langInEng: POLISH
  },
  {
    langCode: 'pt_BR',
    langName: 'Português (Brasil)‏',
    langInEng: PORTUGUESE_BRAZIL
  },
  {
    langCode: 'pt_PT',
    langName: 'Português (Portugal)‏',
    langInEng: PORTUGUESE_PORTUGAL
  },
  {
    langCode: 'ro_RO',
    langName: 'Română‏',
    langInEng: ROMANIAN
  },
  {
    langCode: 'ru_RU',
    langName: 'Русский‏',
    langInEng: RUSSIAN
  },
  {
    langCode: 'sk_SK',
    langName: 'Slovenčina‏',
    langInEng: SLOVAK
  },
  {
    langCode: 'es_MX',
    langName: 'Español (México)',
    langInEng: SPANISH_MEXICO
  },
  {
    langCode: 'es_ES',
    langName: 'Español (España)‏',
    langInEng: SPANISH
  },
  {
    langCode: 'sv_SE',
    langName: 'Svenska‏',
    langInEng: SWEDISH
  },
  {
    langCode: 'th_TH',
    langName: 'ไทย‏',
    langInEng: THAI
  },
  {
    langCode: 'tr_TR',
    langName: 'Türkçe‏',
    langInEng: TURKISH
  },
  {
    langCode: 'uk_UA',
    langName: 'Українська‏',
    langInEng: UKRAINIAN
  },
  {
    langCode: 'vi_VN',
    langName: 'Tiếng Việt‏',
    langInEng: VIETNAMESE
  }
];
